module.exports = __webpack_public_path__ + "static/img/05_calzada.bb02348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/05_calzada.jpg
// module id = yutb
// module chunks = 0